import { render, staticRenderFns } from "./autocomplete2.vue?vue&type=template&id=cb2dd6f0&scoped=true"
import script from "./autocomplete2.vue?vue&type=script&lang=js"
export * from "./autocomplete2.vue?vue&type=script&lang=js"
import style0 from "./autocomplete2.vue?vue&type=style&index=0&id=cb2dd6f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2dd6f0",
  null
  
)

export default component.exports